export const Blurs = {
  sm: "blur(4px)",
  md: "blur(8px)",
  lg: "blur(12px)",
  xl: "blur(20px)",
} as const;

export type Blur = typeof Blurs;
